module.exports = __webpack_public_path__ + "static/img/11.49967b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/11.png
// module id = 9GED
// module chunks = 0